import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  pageHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '.6rem',
    marginBottom: '1.4rem',
  },

  title: {
    flex: '1',
  },
})

export default useStyles
